'use client';

import { type Context, useContext } from 'react';

import { PageContext, type PageDataContext } from './page-context';

export function usePageContext<
  TCmsData extends Record<string, unknown>,
  TPageData extends Record<string, unknown> = Record<string, never>
>(): PageDataContext<TCmsData, TPageData> {
  const context = useContext<PageDataContext<TCmsData, TPageData>>(
    PageContext as unknown as Context<PageDataContext<TCmsData, TPageData>>
  );
  if (!context) {
    throw new Error('usePageContext must be used under PageContextProvider');
  }
  return context;
}
